// @ts-nocheck
import { rawRequest } from "@insite/client-framework/Services/ApiService";
import { BlobFile } from "@store/Framework/Common/Utilities/downloadBlobFile";
import getContenDispositionFilename from "@store/Framework/Common/Utilities/getContenDispositionFilename";

const invoicesPdfUrl = "/api/v1/invoicespdf";

export type InvoicePdf = BlobFile;
export interface GetInvoicePdfApiParameter {
    invoiceNumber: string;
}

export function getInvoicePdf(parameter: GetInvoicePdfApiParameter) {
    const { invoiceNumber } = parameter;
    let filename = `invoice_${invoiceNumber}.pdf`;

    return rawRequest(`${invoicesPdfUrl}/${invoiceNumber}`)
        .then(async response => {
            filename = getContenDispositionFilename(response.headers.get("Content-Disposition")) || filename;
            return new Blob([await response.blob()], { type: response.headers.get("Content-Type") || undefined });
        })
        .then((blob): InvoicePdf => ({ blob, filename }));
}
